export default {
  "dashboard.title": "Willkommen zurück",
  "dashboard.noAccount.title": "Fügen Sie Ihr PAMM-Konto Hinzu",
  "dashboard.noAccount.description": "Sie benötigen ein aktives Investment-PAMM-Konto, um Ihren Benutzer zu aktivieren und die TheClub-Vorteile zu genießen",
  "dashboard.noAccount.skipButton": "Überspringen",
  "dashboard.noAccount.addAccountButton": "PAMM-Konto Hinzufügen",
  "dashboard.subtitle": "Gestalten Sie Ihre Zukunft mit The Club",
  "dashboard.totalEarnings.lifetime": "Gesamte Lebenslange Gewinne",
  "dashboard.totalEarnings.lastMonth": "Gesamte Gewinne",
  "dashboard.totalEarnings.breakdown.accounts": "Trading-Kontogewinne",
  "dashboard.totalEarnings.breakdown.commissions": "Kommissionen deiner Community",
  "dashboard.community.combined.title": "Meine Community-Übersicht",
  "dashboard.userInfo.combined.title": "Profil",
  "dashboard.charts.totalEarningsOverTime": "Gesamte Gewinne über die Zeit",
  "dashboard.userProfile.title": "Profil-Übersicht",
  "dashboard.userProfile.username": "Benutzername",
  "dashboard.userProfile.memberSince": "Mitglied seit",
  "dashboard.userProfile.rank": "Rang",
  "dashboard.userProfile.status": "Status",
  "dashboard.userStats.title": "Schnellstatistiken",
  "dashboard.userStats.referralLink": "Empfehlungslink",
  "dashboard.userStats.commissionModel": "Provisionsmodell",
  "dashboard.userStats.communityValue": "Community-Wert",
  "dashboard.userStats.linkCopied": "Link kopiert!",
  "dashboard.userStats.linkCopiedDesc": "Empfehlungslink in die Zwischenablage kopiert",
  "dashboard.userStats.rank": "Rang",
  "dashboard.profits.lifetime": "Gesamterträge des Trading-Kontos",
  "dashboard.profits.lastMonth": "Erträge des Trading-Kontos im letzten Monat",
  "dashboard.profits.accountsProfits.title": "Erträge des Trading-Kontos",
  "dashboard.profits.commissions.title": "Kommissionen deiner Community",
  "dashboard.commissions.lifetime": "Lebenslange Provisionen",
  "dashboard.commissions.lastMonth": "Provisionen",
  "dashboard.commissions.lastMonthWithMonth": "Provisionen",
  "dashboard.commissions.currentBalance": "Aktueller Saldo",
  "dashboard.commissions.totalPaid": "Gesamt bezahlt",
  "dashboard.community.totalReferrals": "Gesamte Empfehlungen",
  "dashboard.community.totalReferralsDesc": "Alle Ebenen kombiniert",
  "dashboard.community.communityValue": "Wert Ihrer Community",
  "dashboard.community.communityValueDesc": "Gesamtwert Ihrer Gemeinschaft",
  "dashboard.mycommunity.title": "Meine Community",
  "dashboard.charts.profitsOverTime": "Erträge des Trading-Kontos im Zeitverlauf",
  "dashboard.charts.commissionsOverTime": "Provisionen über die Zeit",
  "dashboard.charts.accountProfit": "Gewinn des Trading-Kontos",
  "dashboard.charts.commissionAmount": "Provisionsbetrag",
  "dashboard.charts.totalEarnings": "Gesamte Gewinne",
  "dashboard.months.jan": "Jan",
  "dashboard.months.feb": "Feb",
  "dashboard.months.mar": "Mär",
  "dashboard.months.apr": "Apr",
  "dashboard.months.may": "Mai",
  "dashboard.months.jun": "Jun",
  "dashboard.months.jul": "Jul",
  "dashboard.months.aug": "Aug",
  "dashboard.months.sep": "Sep",
  "dashboard.months.oct": "Okt",
  "dashboard.months.nov": "Nov",
  "dashboard.months.dec": "Dez",
  "dashboard.monthsFull.jan": "Januar",
  "dashboard.monthsFull.feb": "Februar",
  "dashboard.monthsFull.mar": "März",
  "dashboard.monthsFull.apr": "April",
  "dashboard.monthsFull.may": "Mai",
  "dashboard.monthsFull.jun": "Juni",
  "dashboard.monthsFull.jul": "Juli",
  "dashboard.monthsFull.aug": "August",
  "dashboard.monthsFull.sep": "September",
  "dashboard.monthsFull.oct": "Oktober",
  "dashboard.monthsFull.nov": "November",
  "dashboard.monthsFull.dec": "Dezember",
  "dashboard.loading": "Dashboard-Daten werden geladen...",
  "dashboard.error": "Fehler beim Laden der Dashboard-Daten",
  "dashboard.status.active": "Aktiv",
  "dashboard.status.inactive": "Inaktiv",
  "dashboard.profits.lastMonthWithMonth": "Erträge des Trading-Kontos",
};
